import * as faIcons from '@fortawesome/free-solid-svg-icons';

// In a production build, `@fortawesome/free-solid-svg-icons` exposes each icon
// as a lazy getter (e.g. `faTrashAlt: () => I.B.e.E`). When an alias's module
// indirection fails to initialize, reading that property THROWS
// ("can't access property 'e', I.B is undefined") — which white-screens the
// whole page because the throw happens at `faIcons[name]`, before the icon is
// ever rendered. Resolve defensively so a broken icon just renders nothing.
export function resolveFaIcon(name) {
  if (!name || typeof name !== 'string') return undefined;
  try {
    return faIcons[name];
  } catch {
    return undefined;
  }
}
